import type { EstoreReportRowDto } from "@/api/dtos";
import type { EstoreReportRow } from "@/api/report/_models/EstoreReport";

const KEY = "Order Number";

/** DTO → domain for one eStore row: the "Order Number" dedupe key lifted to `id`, every column kept in `fields`. */
export const toEstoreReportRowFromDto = (dto: EstoreReportRowDto): EstoreReportRow => {
  const id = dto[KEY] ?? "";

  return {
    id,
    fields: dto,
  };
};
